import { render, staticRenderFns } from "./c-contact-address-book-add-edit.vue?vue&type=template&id=13c8d342&scoped=true&"
import script from "./c-contact-address-book-add-edit.vue?vue&type=script&lang=js&"
export * from "./c-contact-address-book-add-edit.vue?vue&type=script&lang=js&"
import style0 from "./c-contact-address-book-add-edit.vue?vue&type=style&index=0&id=13c8d342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c8d342",
  null
  
)

export default component.exports